import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getToken, getStoredUser, setStoredUser, signOut as doSignOut, fetchMe } from "@/lib/auth";

const AuthContext = createContext({
  user: null,
  loading: true,
  signedIn: false,
  refresh: async () => {},
  signOut: () => {},
  setUser: () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(!!getToken());

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await fetchMe();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleSignOut = () => {
    doSignOut();
    setUser(null);
  };

  const setAuthedUser = (u) => {
    setStoredUser(u);
    setUser(u);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        signedIn: !!user,
        refresh,
        signOut: handleSignOut,
        setUser: setAuthedUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
